/**
 * Ein Scherz mit Verfallsdatum: Am **11.09.2026** heißt Janis Meyer auf dem
 * TeamDaily-Board Jonas Meyer, an jedem anderen Tag nicht.
 *
 * Auf Wunsch von Florian Fuchs (10.09.2026) eingebaut. Das steht hier so
 * offen, damit niemand später einen Fehler sucht: Wer am 11.09. auf das Board
 * sieht und sich über den Namen wundert, findet die Erklärung an genau der
 * Stelle, an der er nachschaut. Ein stiller Namenstausch im Code wäre
 * derselbe Gag mit halbem Spaß und doppeltem Ärger.
 *
 * **Maßgeblich ist der Board-Tag, nicht die Uhr.** Wer am 11.09. den Vortag
 * aufruft, sieht Janis; wer am 12.09. auf den 11.09. zurückblättert, sieht
 * Jonas. Das ist die einzige Fassung, die sich ohne eingefrorene Systemzeit
 * prüfen lässt, und sie kippt nicht mitten in der Nacht.
 *
 * **Nach dem 11.09.2026 gehört diese Datei gelöscht**, samt der vier
 * Aufrufstellen. Der Wächtertest daneben hält bis dahin fest, dass sie an
 * jedem anderen Tag nichts tut.
 */

const SCHERZ_TAG = "2026-09-11";
const ECHTER_NAME = "Janis Meyer";
const SCHERZ_NAME = "Jonas Meyer";

/** Der Name, wie er am gewählten Board-Tag angezeigt wird. */
export function anzeigeName(fullName: string, boardDatum: string): string {
  if (boardDatum !== SCHERZ_TAG) return fullName;
  return fullName === ECHTER_NAME ? SCHERZ_NAME : fullName;
}
